import React, { useEffect, useState } from 'react'
import { APP_CONTENT_TYPE, PUBLIC_HEADER_TABS, PUBLIC_TABS } from '../../utils/AppEnumerations';
import { IAppContent, fetchContentManagementApi } from './PrivacyPolicyController';
import CustomEditor from '../../screens/product-services/Web/CustomEditor';
import ICImage from '../../core-component/ICImage';
import UseTranslationHook from '../../hooks/UseTranslationHook';
import CopyrightFooter from '../../components/common/CopyrightFooter';
import PublicHeader from '../public-header/PublicHeader';
import { gsap } from 'gsap';
const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState<IAppContent>();
    const { t } = UseTranslationHook();
    useEffect(() => {
        document.title = PUBLIC_TABS.PrivacyPolicy;
        fetchContentManagementApi(setPolicy, APP_CONTENT_TYPE.PrivacyPolicy);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);
    useEffect(() => {
        setTimeout(async () => {
            gsap.to(`.contact-banner`, {
                scrollTrigger: {
                    trigger: ".contact-section",
                },
                opacity: 1,
                scale: 2,
                ease: "power2.out",
                duration: 2,
            })
            gsap.to(`.privacy-policy-head`, {
                opacity: 1,
                yPercent: '40',
                ease: "power2.out",
                duration: 2,
            })
            gsap.to(`.privacy-policy-section`, {
                opacity: 1,
                yPercent: '120',
                ease: "power2.out",
                duration: 2,
            })
        }, 2000);
    })
    const sentence = t("sentence");
    const speed = 30;
    return (
        <div className='bg-skin-home-bg'>
            <div className='relative '>
                <div className='h-24'> <PublicHeader activeTab={PUBLIC_HEADER_TABS.PrivacyPolicy} /></div>
                <div className='w-full'>
                    <ICImage
                        className="h-[450px] w-full object-fill"
                        src={require('../../assets/image/privacy-policy.png')}
                        scaled={false}
                    />
                </div>
                <div className='flex justify-center flex-row'>
                    <div className='privacy-policy-head'>
                        <h1 className='text-7xl text-skin-home-text text-center'>{t("privacy_policy")}</h1>
                    </div>                    
                </div>
            </div>
            <div className='top flex justify-center p-3 my-6'>
                <div className='lg:w-3/5 w-full'><CustomEditor serviceDesc={policy?.value} containerClassName='!text-xl !leading-9 !text-skin-home-text' /></div>
            </div>
            <CopyrightFooter />
        </div>
    )
}

export default PrivacyPolicy